import React from 'react';
import { useAuthContext } from '@bettercomp/ams-spa-auth-react';
import { AmsWorkspaceSwitcher } from './AmsWorkspaceSwitcher';
import { LegacyTenancySwitcher } from './LegacyTenancySwitcher';

/**
 * Picks the switcher that matches the session in play.
 *
 * Branches on the presence of an AMS session, the same signal
 * `useTenantActions.refreshSessionAfterSwitch` already uses, rather than on a feature flag: the two
 * switchers are not alternative implementations of one behaviour that could be toggled, they belong
 * to two different session types and only one of them can work at a time.
 */
export const TenancySwitcher = () => {
  const { session } = useAuthContext();

  return session ? <AmsWorkspaceSwitcher /> : <LegacyTenancySwitcher />;
};
